
<div id="{{chartId}}" class="pointer"></div>